<template lang="pug">
  section.section.home#home
    video.home__video(autoplay loop muted playsinline, @ended="playVideo", ref="video", preload="auto")
      source(src="~@/assets/vidos.mp4", type="video/mp4")
      source(src="~@/assets/vidos.ogg", type="video/ogg")
      | Your browser does not support the video tag.
    Navigation
    .logo(data-type="parallax", data-depth="-0.4")
      img.logo__image(src="../assets/logo.png", v-fade)
      Button.logo__button(
        buttonText="Искусство жить", withArrow, isGradient, isLink, link="#artofliving"
      )
    
</template>

<script>
import Navigation from "./Navigation.vue";
import Button from "./Button.vue";

export default {
  name: "Home",
  components: {
    Navigation,
    Button
  },
  methods: {
    playVideo() {
      this.$refs.video.load();
      this.$refs.video.play();
    }
  }
};
</script>

<style lang="scss">
@import "../styles/main.scss";

.home {
  width: 100%;
  height: 65vh;
  position: relative;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-image: url("~@/assets/video-dummy.jpg") no-repeat;
  background-size: cover;

  @include from("lg") {
    height: 100vh;
  }
  @include from("xl") {
    display: block;
  }

  &__video {
    position: absolute;
    z-index: -1;
    width: auto;
    left: 50%;
    transform: translateX(-50%);
    height: 100%;

    @include from("lg") {
      height: 120vh;
    }
    @include from("xl") {
      left: 0;
      transform: translateX(0);
    }
  }
}

.logo {
  text-align: center;
  margin-top: 5%;

  @include from("xxxl") {
    margin-top: 12%;
  }
  &__image {
    max-width: 100%;
    box-sizing: border-box;
    padding: 20px;

    @include from("sm") {
      max-width: 60%;
    }
    @include from("xl") {
      max-width: 100%;
    }
  }
  &__button {
    @include from("xl") {
      margin: 52px auto 0;
    }
  }
}
</style>
